import React, {useEffect} from 'react';
import SignupUI from '../view/SignupUI';
import {useNavigate, useSearchParams} from 'react-router-dom';
import SignupStore from '../store/SignupStore';
import {inject, observer} from 'mobx-react';
import {getSubscriptionNameFromTier} from '../../../../data/models/Subscription/Subscription';

interface Props {
  signupStore?: SignupStore;
}

const SignupContainer = inject('signupStore')(
  observer(({signupStore}: Props) => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const selectedTier = params.get('selected_tier');

    useEffect(() => {
      if (params.get('selected_tier') === null) {
        navigate('/subscription_tier', {replace: true});
      }
      return () => {
        signupStore!.clearErrors();
      };
    }, []);

    const onSignUp = async (email: string, password: string, name: string) => {
      if (selectedTier) {
        const result = await signupStore?.registerUser(
          email,
          password,
          name,
          parseInt(selectedTier, 10),
        );
        if (result) {
          signupStore!.sendEmailVerification().then(() => {
            navigate('/auth/confirm_email');
          });
        }
      } else {
        navigate('/subscription_tier', {replace: true});
      }
    };

    const clearErorrs = () => {
      signupStore!.clearErrors();
    };

    const getPlanName = (selectedTier: unknown): string => {
      const parsed = Number(selectedTier);
      if (Number.isNaN(parsed)) return '';

      return getSubscriptionNameFromTier(parsed) ?? '';
    };

    return (
      <SignupUI
        onSignUp={onSignUp}
        errors={signupStore!.errors}
        isLoading={signupStore!.isLoading}
        clearErorrs={clearErorrs}
        isTrial={selectedTier === '0'}
        planName={getPlanName(selectedTier)}
      />
    );
  }),
);

export default SignupContainer;
